module.exports = {
  SAVE_BRANDS: "SAVE_BRANDS",
  CLEAR_BRANDS: "CLEAR_BRANDS",
};
